/* eslint-disable global-require */

import angular from 'angular';

import './profile-tag.style.scss';

export const UserProfileImageComponent = {
  selector: 'profileTag',
  restrict: 'E',
  bindings: {
    userId: '@',
  },
  controllerAs: '$ctrl',
  template: /* html */ `
    <div class="profile-tag tag">
      <profile-image user-id="{{ $ctrl.userId }}"></profile-image>

      <user-name user-id="$ctrl.userId"></user-name>
    </div>
  `,
};

export default angular.module('autoboard.profileTag', [])
  .component(UserProfileImageComponent.selector, UserProfileImageComponent)
  .name;
